import { Tooltip } from '@material-ui/core';
import { IconButton, Menu, MenuItem } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ExcelJS from 'exceljs';
import { useState } from 'react';
import { hoverStyle } from "styles/main";

export function TemplateExcel({list}){

  const [openTemplateMenu, setOpenTemplateMenu] = useState(false)
  const [anchorSettings, setAnchorSettings] = useState(undefined);// якорь для  меню настроек
  
  const templates = {
    "simpleTeplateCreateDelivery": {func: downloadSimpleTemplate, text: "Скачать простой шаблон"},
    "warehouseTeplateCreateDeliveryOzon": {func: downloadOZONTemplateWithDelivery, text: "Скачать шаблон с распределением по складам"}
  }

  return (
    <div>
      <Tooltip title="Шаблоны">
        <IconButton aria-label="templateMenu" onClick={(event) => {setOpenTemplateMenu(true); setAnchorSettings(event.currentTarget)}}>
            <FileDownloadIcon
                sx={{
                    transition: 'all 0.3s ease',
                    '&:hover': hoverStyle
                }}
            />
        </IconButton>
      </Tooltip>
      <Menu
          id="basic-menu"
          // @ts-ignore          
          anchorEl={anchorSettings}          
          open={openTemplateMenu}
          onClose={() => {setOpenTemplateMenu(false)}}
          MenuListProps={{
              'aria-labelledby': 'basic-button',
          }}
      >
          {
            list.map((el) => {
              return (
                <MenuItem onClick={templates[el].func}>{templates[el].text}</MenuItem>      
              )
            })
          }
      </Menu>
    </div>
  )

}

const downloadTemplate = async (filename, columns) => {
  // 1. Создаем новую книгу и лист
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Мои данные');

  worksheet.columns = columns
  
  // Генерируем файл как буфер
  const buffer = await workbook.xlsx.writeBuffer();

  //Создаем Blob и скачиваем файл
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = `${filename}.xlsx`
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
}


//Простой шаблон шк + 
export const downloadSimpleTemplate = async (event) => {
    if (event) {
        event.preventDefault(); // Предотвращаем действие по умолчанию
        event.stopPropagation(); // Останавливаем всплытие события
    }

    let filename = 'Шаблон сделки';
    let columns = [
      { header: 'Баркод товара', key: 'barcode'},
      { header: 'Кол-во товаров', key: 'count'},
    ];

    await downloadTemplate(filename, columns)

}

export const downloadOZONTemplateWithDelivery = async (event) => {
    if (event) {
        event.preventDefault(); // Предотвращаем действие по умолчанию
        event.stopPropagation(); // Останавливаем всплытие события
    }

    let filename = 'Шаблон сделки расширенный ozon';
    let columns = [
      { header: 'Номер поставки', key: 'barcode'},
      { header: 'Склад хранения', key: 'warehouse'},
      { header: 'OzonID', key: 'OzonID'},
      { header: 'Артикул', key: 'art'},
      { header: 'Наименование товара', key: 'title'},
      { header: 'В поставке (шт.)', key: 'count'},
      { header: 'Объем (л.)', key: 'volume'},

    ];

    await downloadTemplate(filename, columns)
}